// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import {
    getRecentShipmentsInformation,
    RecentShipmentsInformationModel,
} from "@stoneage/App/Services/RecentShipments/RecentShipmentsService";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";

export interface RecentShipmentsApiParameter extends ApiParameter {
    numberOfShipments?: string;
}

type HandlerType = ApiHandler<
    RecentShipmentsApiParameter & HasOnSuccess<RecentShipmentsInformationModel> & HasOnError,
    RecentShipmentsInformationModel
>;

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getRecentShipmentsInformation(props.parameter?.numberOfShipments);
    } catch (e) {
        props.parameter.onError?.();
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameters, RequestDataFromApi, ExecuteOnSuccessCallback];

const loadRecentShipmentsData = createHandlerChainRunner(chain, "LoadRecentShipmentsData");
export default loadRecentShipmentsData;
